import { Navigate } from "react-router-dom";
import Spinner from "../CommonComponents/Spinner";

function ProtectedRoute({ user, allowedRoles, loadingUser, children }) {
    if (loadingUser) {
        return <Spinner />
    }

    if (!user) {
        return <Navigate to="/prijava" />;
    }

    if (!allowedRoles.includes(user.role)) {
        return <Navigate to="/accessDenied" />;
    }

    return children;
}

export default ProtectedRoute;
